import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TokenStorageService } from '../services/token-storage.service';

export const userGuard: CanActivateFn = () => {
  const store = inject(TokenStorageService);
  const router = inject(Router);
  const token = store.token$();
  const currentUser = store.currentUser$();
  const roles = currentUser?.roles ?? [];
  const hasAccess =
    token &&
    currentUser &&
    currentUser.roles &&
    Array.isArray(roles) &&
    roles.some((r: string) => r === 'ROLE_USER' || r.startsWith('ROLE_USER_'));

  if (hasAccess) return true;

  router.navigate(['/auth']);
  return false;
};
